import produce from 'immer'

import { FETCH_TEMPLATES, FETCH_TEMPLATES_SUCCESS, FETCH_TEMPLATES_FAILURE } from '../actions/types'

export const initialTemplateState = {
  id: null,
  content: null,
  indexPattern: null,
  name: null,
  version: null,
  order: null,
}

export const initialState = {
  allIds: [],
  byId: {},
  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_TEMPLATES: {
      draft.fetching = true
      break
    }
    case FETCH_TEMPLATES_SUCCESS: {
      const templates = payload

      // Update async state flags
      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.lastFetched = new Date()

      // Reset all templates
      draft.byId = {}
      draft.allIds = []

      // Add all templates to state
      for (const template of templates) {
        const id = template.name
        if (draft.allIds.indexOf(id) < 0) {
          draft.allIds.push(id)
        }

        draft.byId[id] = {
          ...template,
          id,
        }
      }

      break
    }
    case FETCH_TEMPLATES_FAILURE: {
      const error = payload

      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
